export const isEqual = (obj1, obj2) => {
  const props1 = Object.getOwnPropertyNames(obj1)
  const props2 = Object.getOwnPropertyNames(obj2)

  if (props1.length !== props2.length) {
    return false
  }

  for (let i = 0; i < props1.length; i++) {
    const prop = props1[i]
    const bothAreObjects = typeof (obj1[prop]) === 'object' &&
      (obj1[prop]) !== null &&
      typeof (obj2[prop]) === 'object' &&
      (obj2[prop]) !== null

    if ((!bothAreObjects && (obj1[prop] !== obj2[prop])) ||
      (bothAreObjects && !isEqual(obj1[prop], obj2[prop]))) {
      return false
    }
  }

  return true
}
